import {
  CancelEdgePaymentLinkActionPayload,
  CancelPaymentLinkActionPayload,
} from 'screens/Products/Plural/PaymentLinks/typing';
import { MerchantIdType, TransactionIdType } from './typing';
import { GetImeiDetailsActionType } from 'screens/Products/Plural/payment/typing';
import { SubscriptionPayloadProps } from 'screens/Products/Plural/Subscriptions/typing';

export default {
  LOGIN: 'api/v1/dashboard/auth/merchant/unified/user/Login',
  FETCH_LOGIN_OTP: 'api/v1/dashboard/auth/merchant/unified/user/fetchOTPToken',
  VALIDATE_LOGIN_OTP:
    'api/v1/dashboard/auth/merchant/unified/login/authenticate/otp',
  FETCH_MERCHANT: (merchantId, email): string =>
    `api/v1/dashboard/auth/merchant/unified/login/data/${merchantId}/${email}`,
  NEWUSER: (merchantId, email): string =>
    `plural-onboarding/v1/newaccount/${merchantId}/${email}`,
  RESEND_EMAIL: 'self-serve/v1/resendEmail',
  SIGN_UP: 'plural-onboarding/v1/signup',
  FORGET_PASSWORD: 'api/v1/dashboard/auth/merchant/user/forgetpassword',
  USER_ENV: (emailid: string): string =>
    `api/v1/dashboard/auth/merchant/liveOrTest/${emailid}`,
  VALIDATE_OTP:
    'api/v1/dashboard/auth/merchant/unified/user/forgetpassword/validate/otp',
  SAVE_NEW_PASSWORD:
    'api/v1/dashboard/auth/merchant/unified/user/forgetpassword/save/new/password',
  LOGOUT: 'api/v1/dashboard/auth/merchant/user/logout',
  CHANGE_PASSWORD: 'api/v1/dashboard/auth/merchant/unified/user/changepassword',
  REFRESH_TOKEN: 'api/v1/dashboard/auth/merchant/verify/token',
  NEW_SIGN_UP: 'api/v1/dashboard/auth/merchant/user/new/login',
  SALESFORCE_SIGN_UP: 'services/apexrest/api/PluralCreateLead',
  SALESFORCE_EDGE_SIGN_UP: 'services/apexrest/api/PluarlMIDSuccessResponse',
  SALESFORCE_FORM2: 'services/apexrest/api/PluralForm2Details',
  SALESFORCE_RESUBMIT: 'services/apexrest/api/PluralUpdatedKYCDocument',
  UPDATE_ACCOUNT: 'api/v1/dashboard/transaction/merchant/data',
  TOGGLE_ENV: 'api/v1/dashboard/auth/merchant/switch/env',
  SALESFORCE_AUTH: 'api/v1/dashboard/auth/merchant/getSalesforceToken',
  CASEMANAGEMENT_AUTH: 'api/v1/dashboard/auth/merchant/getCaseManagementToken',
  SIGNZY_AUTH: 'api/v1/dashboard/auth/merchant/getSignzyToken',
  SET_COOKIES: 'api/v1/dashboard/auth/merchant/cookie/set',
  CHECK_COOKIES: 'api/v1/dashboard/auth/merchant/cookie/check',
  ANALYTICS: (merchantId: string, isAdmin: boolean): string =>
    `api/v1/dashboard/transaction/analytics/data/rootuser/${isAdmin}/merchant/${merchantId}`,
  VALIDATION_ERRORS: 'api/v1/dashboard/transaction/home/ErrorText',
  GATEWAY_LIST: (merchantId: string): string =>
    `api/v1/dashboard/transaction/gateway/GetMappedGatewaysWithStatus/${merchantId}`,
  UNMAPPED_GATEWAY_LIST: (merchantId: string | number): string =>
    `api/v1/dashboard/transaction/gateway/GetUnmappedGateways/${merchantId}`,
  GATEWAY_CONFIGURATIONS: (
    gateway: string,
    merchantId: string | number,
    mode: boolean
  ): string =>
    `api/v1/dashboard/transaction/gateway/GetConfigurationForGateway/${gateway}/${mode}/${merchantId}`,
  SAVE_GATEWAY: 'api/v1/dashboard/transaction/gateway/SaveGateway',
  PREFERNCE_GATEWAY: (merchantId: string | number): string =>
    `api/v1/dashboard/transaction/gateway/ViewActiveSimpleLogic/${merchantId}`,
  ACTIVE_PRIORITY_LOGIC: (merchantId: string | number): string =>
    `api/v1/dashboard/transaction/gateway/ViewActivePriorityLogic/${merchantId}`,
  SAVE_CUSTOM_LOGIC: 'api/v1/dashboard/transaction/gateway/SaveCustomLogic',
  UPDATE_PREFERNCES: (
    preference: string,
    merchantId: string | number
  ): string =>
    `api/v1/dashboard/transaction/gateway/SaveSimpleLogic/${preference}/1/${merchantId}`,
  PRIORITY_LOGICS_LIST: (merchantId: string): string =>
    `api/v1/dashboard/transaction/gateway/GetAllMappedPriorityLogics/${merchantId}`,
  SMART_ROUTING_PREFERENCE_SCORES_LIST: (
    merchantId: number,
    preferenceType: string
  ): string =>
    `api/v1/dashboard/transaction/gateway/GetMapped${preferenceType}/${merchantId}`,
  SMART_ROUTING_CREATE_PREFERENCE_SCORES: (preferenceType: string): string =>
    `api/v1/dashboard/transaction/gateway/Create${preferenceType}RouteForMerchant`,
  SMART_ROUTING_DELETE_PREFERENCE_SCORES: (preferenceType: string): string =>
    `api/v1/dashboard/transaction/gateway/Delete${preferenceType}RouteForMerchant`,
  VIEW_SIMPLE_ROUTING_LOGIC: (merchantId: number): string =>
    `api/v1/dashboard/transaction/gateway/ViewActiveSimpleLogic/${merchantId}`,
  GET_ALL_CARD_BRAND_NAMES:
    'api/v1/dashboard/transaction/gateway/AllCardBrandNames',
  GET_ALL_ISSUER_NAMES:
    'api/v1/dashboard/transaction/gateway/GetAllIssuerNames',
  GET_ACTIVE_WEBHOOK_EVENTS:
    'api/v1/dashboard/transaction/Settings/GetActiveWebhookEventsForMerchant/merchantId',
  GET_ACTIVE_EDGE_WEBHOOK_EVENTS:
    'api/v1/unification/pg/dashboard/settings/webhookEvents',
  V3_MERCHANT_WEBHOOK:
    'api/v2/dashboard-bff/self-serve/onboard/webhook',
  GET_ACTIVE_EDGE_PAYMENT_LINKS_WEBHOOK_EVENTS:
    'api/v1/unification/pg/dashboard/paymentlink/webhook',
  UPDATE_PAYMENT_LINKS_WEBHOOK_API:
    'api/v1/unification/pg/dashboard/paymentlink/webhook',
  GET_MERCHENT_SETTINGS:
    'api/v1/dashboard/transaction/Settings/GetMerchantSettings/merchantId',
  UPDATE_MERCHENT_GENERAL_SETTINGS:
    'api/v1/dashboard/transaction/Settings/UpdateMerchantGeneralSettings',
  UPDATE_MERCHENT_WEBHOOK:
    'api/v1/dashboard/transaction/Settings/UpdateWebhookEventsForMerchant',
  GET_PAYMENT_LIST:
    'api/v1/dashboard/transaction/transaction/GetAllTransactionsOnMerchant',
  GET_EDGE_TRANSACTION_LIST: 'api/v1/unification/pg/dashboard/transaction',
  GET_EDGE_V3_ORDER_LIST: 'api/v3/dashboard/order-history',
  GET_ORDER_LEVEL_SUMMARY: 'api/v3/dashboard/order/summary',
  GET_ORDER_SUMMARY_METRICS: 'api/v3/dashboard/order/summary/metrics',
  PACB_UPLOAD_INVOICE: 'api/v3/dashboard-bff/pa-cb/orders',
  PACB_UPLOAD_AWB: 'api/v3/dashboard-bff/pa-cb/orders',
  PACB_GET_INVOICE_STATUS: 'api/v3/dashboard-bff/pa-cb/orders',
  PACB_GET_AWB_STATUS: 'api/v3/dashboard-bff/pa-cb/orders',
  PACB_BULK_UPLOAD: 'api/v3/dashboard-bff/pa-cb/bulk-upload',
  PACB_BULK_UPLOAD_TEMPLATE_DOWNLOAD: 'api/v3/dashboard-bff/pa-cb/bulk-upload/template',
  PACB_BULK_UPLOAD_HISTORY: 'api/v3/dashboard-bff/pa-cb/bulk-upload/history',
  GET_SETTLEMENT_DETAILS: 'api/v1/settlement/details',
  GET_ORDER_DETAILS: 'api/v3/dashboard/order/details',
  GET_ORDER_REFUND_SETTLEMENT: 'api/v3/dashboard/order/refunds-settlements',
  GET_EDGE_REFUND_TRANSACTION_LIST:
    'api/v1/unification/pg/dashboard/transaction/refund',
  GET_EDGE_PAYMENT_TRANSACTION_LIST:
    'api/v1/unification/pg/dashboard/transaction/payment',
  GET_EDGE_TRANSACTION_FILTERS:
    'api/v1/unification/pg/dashboard/transaction/filter/mapping',
  GET_WALLET_NAME_FILTER: 'api/v3/dashboard/wallet/names',
  GET_EDGE_TRANSACTION_DETAILS: 'api/v1/unification/pg/dashboard/transaction/details',
  GET_REFUND_LIST: ({
    transactionType,
    merchantId,
  }: {
    transactionType: string | number;
    merchantId: string | number;
  }): string =>
    `api/v1/dashboard/transaction/transaction/GetAllTransactionsOnMerchant/${transactionType}/${merchantId}`,
  PAYMENT_GET_ORDER_TRANSACTION_DETAILS:
    'api/v1/dashboard/transaction/order/GetAllOrdersWithCriteria',
  GET_ACTIVE_USERS: 'api/v1/dashboard/transaction/user/unified/all',
  GET_ALL_ROLES: 'api/v1/dashboard/transaction/user/unified/roles/all',
  GET_ALL_PERMISSIONS_LIST: 'api/v1/dashboard/transaction/user/permissions',
  CREATE_NEW_ROLE: 'api/v1/dashboard/transaction/user/unified/create/role',
  GET_ALL_GATEWAYS: 'api/v1/dashboard/transaction/transaction/GetAllGateways',
  GET_ALL_TRANSACTION_STATUS:
    'api/v1/dashboard/transaction/transaction/GetAllTransactionStatus',
  CREATE_NEW_USER: 'api/v1/dashboard/transaction/user/unified/create',
  UPDATE_USER_DETAILS: 'api/v1/dashboard/transaction/user/unified/update',
  DELETE_USER: 'api/v1/dashboard/transaction/user/unified/remove',
  RESEND_INVITATION:
    'api/v1/dashboard/transaction/user/unified/resend/invitation/user',
  GET_CHECKOUT_THEME:
    'api/v1/dashboard/transaction/settings/get/checkout/data/merchant',
  GET_DASHBOARD_THEME:
    'api/v1/dashboard/transaction/settings/get/dashboard/theme/merchant',
  GET_EDGE_CHECKOUT_THEME: 'api/v1/unification/pg/dashboard/settings/checkout',
  UPDATE_EDGE_CHECKOUT_THEME:
    'api/v1/unification/pg/dashboard/settings/checkout',
  UPDATE_CHECKOUT_THEME:
    'api/v1/dashboard/transaction/settings/update/checkout/data',
  UPDATE_DASHBOARD_THEME:
    'api/v1/dashboard/transaction/settings/update/dashboard/theme/data',
  CREATE_REFUND: 'api/v1/dashboard/transaction/refund/initiate',
  CREATE_EDGE_REFUND: 'api/v1/unification/pg/dashboard/refund',
  GET_REFUND_BULK_UPLOAD_HISTORY_LIST: `api/v1/dashboard/transaction/refund/batch/filter`,
  GET_REFUND_BULK_UPLOAD_CSV_TEMPLATE: `api/v1/dashboard/transaction/refund/batch/sample/file/download`,
  UPLOAD_BULK_REFUND: (merchantId: number | string): string =>
    `api/v1/dashboard/transaction/refund/batch/initiate/file/${merchantId}`,
  CHANGE_GATEWAY_STATUS:
    'api/v1/dashboard/transaction/merchant/ChangeMerchantGatewayMappingStatus',
  DELETE_PRIORITY_LOGIC: (configId: number, merchantId: number): string =>
    `api/v1/dashboard/transaction/gateway/DeletePriorityLogic/${configId}/${merchantId}`,
  GET_TODAY_TRANSACTIONS_DATA: (merchantId: number): string =>
    `api/v1/dashboard/transaction/transaction/GetTransactionSummary/${merchantId}`,
  GET_EDGE_TODAY_TRANSACTIONS_DATA: `api/v1/unification/pg/dashboard/overview/transaction/summary`,
  GET_OVERVIEW_DATA: (merchantId: string | number): string =>
    `api/v1/dashboard/transaction/transaction/GetAllTransactionDataForCharting/${merchantId}`,
  GET_EDGE_OVERVIEW_DATA: `api/v1/unification/pg/dashboard/overview/transaction/graph`,
  GET_SETTLEMENT_SHORT_SUMMARY: 'v1/settlements/shortSummary',
  GET_EDGE_SETTLEMENT_SHORT_SUMMARY:
    'v1/edge/unification/edgeSettlement/v2/list',
  GET_EDGE_SETTLEMENT_LIST: 'api/v3/dashboard/settlements/list',
  GET_SETTLEMENTS_SEARCH: 'api/v3/dashboard/settlements/search',
  GET_TRANSACTION_FOR_UTR_NUMBER_LIST:
    'api/v3/dashboard/settlements/transaction/list',

  GET_DETUCTION_MODAL_DETAILS: 'api/v3/dashboard/settlements/detail',
  GET_TRANSACTION_DETAILS_FOR_SETTLEMENTS:
    'api/v3/dashboard/settlements/transaction/detail',
  GET_SETTLEMENT_MPR_FILE_LOCATION:
    'api/v3/dashboard/settlements/mpr/file-location',
  GET_EDGE_SETTLEMENT_OVERVIEW: 'api/v3/dashboard/settlements/overview',
  GET_PENDING_SETTLEMENTS_LIST: 'api/v3/dashboard/settlements/pending/list',
  POST_ODS_SETTLEMENT: 'api/v3/dashboard/settlements/ods/request',
  GET_ODS_SETTLEMENT_LIMIT_DATA: 'api/v3/dashboard/settlements/ods/limitData',
  GET_ODS_SETTLEMENT_STATUS: 'api/v3/dashboard/settlements/ods/requestStatus',
  GET_ODS_SETTLEMENT_HISTORY_DATA:
    'api/v3/dashboard/settlements/ods/historyData',
  GET_MERCHANT_ODS_DATA: 'api/v3/dashboard/merchantDetails',
  GET_EDGE_MPR_LIST: 'v1/edge/unification/mpr/list',
  GET_PG_LIST: 'v1/pg/pgList',
  GET_STATUS_LIST: 'v1/plstatus/statusList',
  GET_SETTLEMENT_DETAIL_SUMMARY: 'v1/settlements/detailSummary',
  GET_EDGE_SETTLEMENT_DETAIL_SUMMARY:
    'v1/edge/unification/edgeSettlement/detail',
  GET_SETTLEMENT_DOWNLOAD_URL: 'v1/settlements/downloadSummary',
  GET_EDGE_SETTLEMENT_DOWNLOAD_URL:
    'v1/edge/unification/edgeSettlement/v2/list/download',
  GET_EDGE_MPR_DOWNLOAD_URL: 'v1/edge/unification/mpr/download',
  GET_SETTLEMENT_SYNCNOW_DATA: 'v1/settlements/synchronization',
  GET_OVERVIEW_SETTLEMENT_DATA: (merchantId: MerchantIdType): string =>
    `v1/settlements/overview/${merchantId}`,
  GET_EDGE_OVERVIEW_SETTLEMENT_DATA: `api/v1/unification/pg/dashboard/overview/settlement/summary`,
  BETA_TOGGLE: (emailid: string) =>
    `api/v2/dashboard-bff/self-serve/beta-toggle?emailId=${emailid}`,
  GET_PAYMENT_LINKS_LIST: (id: number | string): string =>
    `api/v1/payment/transaction/transaction/paymentlink/search/${id}`,
  CREATE_PAYMENT_LINK:
    'v1/payment/transaction/transaction/paymentLink/create/payment-link',
  CREATE_EDGE_PAYMENT_LINK: 'api/v1/unification/pg/dashboard/paymentlink',
  GET_EDGE_MERCHANT_CONFIG:
    'api/v1/unification/pg/dashboard/paymentlink/merchantconfig',
  GET_EDGE_PAYMENT_LINK: 'api/v1/unification/pg/dashboard/paymentlink',
  GET_EDGE_PAYMENT_LINK_V3: 'api/v1/unification/pg/dashboard/paymentlink',
  DOWNLOAD_EDGE_PAYMENT_LINK:
    'api/v1/unification/pg/dashboard/paymentlink/download',
  DOWNLOAD_EDGE_PAYMENT_LINK_V3:
    '/api/v3/dashboard/pbl/transaction/list/download',
  GET_EDGE_PAYMENT_LINK_DETAILS: (paymentLinkId: string | number): string =>
    `api/v1/unification/pg/dashboard/paymentlink/${paymentLinkId}`,
  CANCEL_EDGE_PAYMENT_LINK: (
    config: CancelEdgePaymentLinkActionPayload
  ): string =>
    `api/v1/unification/pg/dashboard/paymentlink/cancel/${config.paymentLinkId}`,

  UPDATE_EDGE_PAYMENT_LINK: (paymentLinkId: string | undefined): string =>
    `api/v1/unification/pg/dashboard/paymentlink/update/${paymentLinkId}`,

  UPDATE_PAYMENT_LINK: (
    paymentLinkId: string | undefined,
    merchantId: MerchantIdType
  ): string =>
    `api/v1/payment/transaction/transaction/paymentlink/update/payment-link/${paymentLinkId}/${merchantId}`,
  CANCEL_PAYMENT_LINK: (config: CancelPaymentLinkActionPayload): string =>
    `api/v1/payment/transaction/transaction/paymentlink/cancel/payment-link/${config.merchantId}/${config.paymentLinkId}`,
  GET_AVAILABLE_PAYMENT_MODES: (merchantId: MerchantIdType): string =>
    `api/v1/payment/transaction/transaction/paymentlink/available-payment-modes/${merchantId}`,
  GET_MERCHANT_LIST: `api/v1/dashboard/transaction/merchant/rootuser/merchantList`,
  ADMIN_GET_ACTIVE_USERS: 'api/v1/dashboard/transaction/user/rootuser/all',
  ADMIN_GET_ALL_ROLES: 'api/v1/dashboard/transaction/user/roles/rootuser/all',
  ADMIN_GET_ALL_PERMISSIONS_LIST:
    'api/v1/dashboard/transaction/user/rootuser/permissions',
  ADMIN_CREATE_NEW_ROLE:
    'api/v1/dashboard/transaction/user/rootuser/create/role',
  ADMIN_CREATE_NEW_USER: 'api/v1/dashboard/transaction/user/rootuser/create',
  ADMIN_UPDATE_USER_DETAILS:
    'api/v1/dashboard/transaction/user/rootuser/update',
  ADMIN_DELETE_USER: 'api/v1/dashboard/transaction/user/remove/rootuser/user',
  ADMIN_RESEND_INVITATION:
    'api/v1/dashboard/transaction/user/resend/invitation/rootuser/user',
  GET_ADMIN_CUSTOM_ROUTING_LIST: `api/v1/dashboard/transaction/merchant/rootuser/merchantCustomRouting`,
  UPDATE_MERCHANT_TRM_STATUS: `api/v1/dashboard/transaction/merchant/ChangeStatusOfTRMForMerchant`,
  GET_ADMIN_PRIORITY_LOGIC: `api/v1/dashboard/transaction/merchant/rootuser/getPriorityLogic`,
  PUT_APPROVE_OR_REJECT_LOGIC: `api/v1/dashboard/transaction/merchant/rootuser/approveRejectLogic`,
  UPDATE_ADMIN_PRIORITY_LOGIC: `api/v1/dashboard/transaction/merchant/rootuser/updateCustomizedLogic`,
  MERCHANT_SEARCH: `api/v1/dashboard/transaction/merchant/rootuser/searchMerchant`,
  GET_ADMIN_CUSTOM_ROUTING_AUTO_SUGGEST_LIST: `api/v1/dashboard/transaction/merchant/rootuser/searchCustomizedMerchantList`,
  GET_PAYMENT_LINKS_BULK_UPLOAD_CSV_TEMPLATE: (
    merchantId: MerchantIdType
  ): string => `api/v1/unification/pg/dashboard/bulk-links/files/template`,
  UPLOAD_BULK_PAYMENT_LINKS: (merchantId: number | string): string =>
    `api/v1/unification/pg/dashboard/bulk-links/files/upload`,
  CLIENT_SECRET_KEY: `api/v1/dashboard/auth/merchant/unified/recaptcha/recaptchaKey`,
  VERIFY_CAPTCHA_API: `api/v1/dashboard/auth/merchant/unified/recaptcha/verify`,
  GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY:
    'api/v1/unification/pg/dashboard/bulk-links/files/history',
  DOWNLOAD_PAYMENT_LINK_BULK_UPLOAD_HISTORY_FILE: (
    fileId: number,
    merchantId: number | string
  ): string =>
    `api/v1/unification/pg/dashboard/bulk-links/files/download/${fileId}/${merchantId}`,
  GET_PAYMENT_LINK_STATUS_CODE:
    'api/v1/payment/transaction/transaction/paymentlink/paymentLinkStatus',
  GET_POST_PAYMENT_LINK_CUSTOMIZE_EMAIL: (merchantId: MerchantIdType): string =>
    `api/v1/payment/transaction/transaction/paymentlink/customize-email/${merchantId}`,
  GET_POST_EDGE_PAYMENT_LINK_CUSTOMIZE_EMAIL:
    'api/v1/unification/pg/dashboard/paymentlink/customize/email',
  GET_ALL_REFUND_STATUS:
    'api/v1/dashboard/transaction/refund/GetAllRefundStatus',
  GET_TRM_REDIRECT_URL: 'api/v1/dashboard/auth/merchant/trm/getRedirectUrl',
  VALIDATE_REGISTER_TOKEN: (token: string, isAdmin: boolean): string =>
    `api/v1/dashboard/auth/merchant/validateInviteLink/${token}/${isAdmin}`,
  GET_ALL_UDF: (merchantId: string | number): string =>
    `api/v1/payment/transaction/transaction/udf/getMerchantUDFs/${merchantId}`,
  GET_ALL_EDGE_UDF: 'api/v1/unification/pg/dashboard/paymentlink/customize/udf',
  UPDATE_MERCHANT_PL_CUSTOMIZATION:
    'api/v1/payment/transaction/transaction/udf/rootuser/subscribeUnsubscribeUDFsForMerchant',
  UPDATE_EDGE_MERCHANT_PL_CUSTOMIZATION:
    'api/v1/unification/pg/dashboard/paymentlink/customize/enable',
  UPDATE_ALL_UDF_PL: 'api/v1/payment/transaction/transaction/udf/updateUDF',
  UPDATE_ALL_EDGE_UDF_PL:
    'api/v1/unification/pg/dashboard/paymentlink/customize/udf',
  // PAYOUT ENDPOINTS
  ADD_NEW_BENEFICIARY: 'api/v1/payout/vendor/manage',
  GET_BENEFICIARY_LIST: 'api/v1/payout/vendor/list',
  DOWNLOAD_BENEFICIARY_LIST: 'api/v1/payout/vendor/downloadlist',
  DOWNLOAD_INDIVIDUAL_PAYOUT_LIST:
    'api/v2/dashboard-bff/payouts/v2/report/download',
  APPROVE_REJECT_BENEFICIARIES: 'api/v1/payout/vendor/approve',
  INDIVIDUAL_PAYOUTS: 'api/v2/dashboard-bff/payouts/v2/payments',
  GET_BENEFICIARY_BY_BENEFICIARY_CODE: 'api/v1/payout/vendor/mastercopy',
  APPROVE_REJECT_INDIVIDUAL_PAYOUT: 'api/v1/payout/payout/approve',
  DEACTIVATE_BENEFICIARIES: 'api/v1/payout/vendor/disableBeneficiary',
  BULK_PAYOUTS: 'api/v2/dashboard-bff/payouts/v2/payments/file',
  BULK_PAYOUT_FAILED_RECORDS:
    'api/v2/dashboard-bff/payouts/v2/payments/file/status',
  BULK_PAYOUT_UPLOAD_CSV_TEMPLATE:
    'api/v2/dashboard-bff/payouts/v2/payments/sampleFile/download',
  GET_BULK_BENEFICIARY_LIST: 'api/v1/payout/vendor/filesummary',
  POST_BULK_BENEFICIARY_APPROVE_REJECT: 'api/v1/payout/vendor/approvefile',
  POST_BULK_PAYOUT_APPROVE_REJECT: 'api/v1/payout/payout/approvefile',
  GET_PAYOUT_BULK_UPLOAD_CSV_TEMPLATE: (
    fileKeyword: string,
    merchantId: MerchantIdType,
    isAdmin: boolean
  ): string =>
    `api/v1/payout/common/downloadTemplate?fileKeyword=${fileKeyword}&merchantId=${merchantId}&isAdmin=${isAdmin}`,
  UPLOAD_BULK_BENEFICIARY: 'api/v1/payout/vendor/upload',
  UPDATE_MERCHANT_PAYOUT_MODULE_STATUS:
    'api/v1/dashboard/transaction/merchant/unified/rootuser/payout/status',
  CANCEL_INDIVIDUAL_PAYOUT: (paymentReferenceId: string): string =>
    `api/v2/dashboard-bff/payouts/v2/payments/banks/${paymentReferenceId}/cancel`,
  RESCHEDULE_INDIVIDUAL_PAYOUT: (paymentReferenceId: string): string =>
    `api/v2/dashboard-bff/payouts/v2/payments/${paymentReferenceId}`,
  DOWNLOAD_BULK_PAYOUT_RECORD:
    'api/v2/dashboard-bff/payouts/v2/payments/file/download',
  GET_PAYOUT_OVERVIEW_PENDING_SUMMARY:
    'api/v1/payout/payout/dashboardPendingSummary',
  GET_PAYOUT_OVERVIEW_STATUS_SUMMARY:
    'api/v1/payout/payout/dashboardPayoutStatusSummary',
  GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY:
    'api/v1/payout/payout/dashboardTransactionSummary',
  GET_PAYOUT_MERCHANT_ACOUNT_BALANCE:
    'api/v2/dashboard-bff/payouts/v2/payments/banks/balance',
  GET_PAYOUT_REMITTER_ACCOUNTS_LIST: 'api/v1/payout/remitter/list',
  GET_PAYOUT_CURRENT_ACCOUNTS_LIST: 'api/v1/payout/currentaccount/list',
  ADD_PAYOUT_REMITTER_ACCOUNT: 'api/v1/payout/remitter/add',
  ADD_PAYOUT_CURRENT_ACCOUNT:
    'api/v2/dashboard-bff/payouts/v2/merchants/funding-accounts',
  UPDATE_PAYOUT_REMITTER_ACCOUNT: 'api/v1/payout/remitter/update',
  ACTIVATE_PAYOUT_CURRENT_ACCOUNT:
    'api/v2/dashboard-bff/payouts/v2/merchants/funding-accounts/activate',
  GET_PAYOUT_BANK_LIST: 'api/v2/dashboard-bff/payouts/v2/banks',
  DOWNLOAD_SETTLEMENT_CSV_TEMPLATE: (
    merchantId: number | string
  ): number | string => `api/v1/settlements/download/${merchantId}`,
  EMAIL_ALERT_NOTIFICATION_CONFIG:
    'api/v2/dashboard-bff/payouts/v2/merchants/notifications/email/config',
  MANAGE_EMAIL_ALERT_NOTIFICATION:
    'api/v2/dashboard-bff/payouts/v2/merchants/notifications/email/manage',
  GET_MERCHANT_KYC_ENTITY_TYPES_LIST:
    'api/v1/payout/merchantkyc/kycentitytypes',
  GET_MERCHANT_KYC_DETAILS: 'api/v1/payout/merchantkyc/get',
  GET_PENNY_DROP_PENDING_COUNT: 'api/v1/payout/vendor/getpennydroppendingcount',
  GET_PAYOUT_PENDING_COUNT: 'api/v1/payout/payout/getPendingPayoutDetails',
  POST_UPDATE_MERCHANT_KYC_DETAILS: 'api/v1/payout/merchantkyc/manage',
  GET_PAYOUT_UPI_ACCOUNT_LIST: 'api/v1/payout/upiaccount/list',
  ADD_PAYOUT_UPI_ACCOUNT:
    'api/v2/dashboard-bff/payouts/v2/merchants/payment-mode-accounts',
  ACTIVATE_PAYOUT_UPI_ACCOUNT: (accRefId): string =>
    `api/v2/dashboard-bff/payouts/v2/merchants/payment-mode-accounts/${accRefId}/activate`,
  GET_MERCHANT_DETAILS: 'api/v2/dashboard-bff/payouts/v2/merchants',
  ADD_PUBLIC_KEY: 'api/v2/dashboard-bff/payouts/v2/merchants',
  SCHEDULE_NEW_INDIVIDUAL_PAYOUT: 'scheduler/addJob',
  SCHEDULE_INDIVIDUAL_PAYOUT_LIST: 'scheduler/getlistjob',
  APPROVE_REJECT_SCHEDULE_INDIVIDUAL_PAYOUT: 'scheduler/approvejob',
  GET_IMEI_DETAILS: (
    transactionId: TransactionIdType,
    merchantId: MerchantIdType
  ): string =>
    `api/v1/dashboard/transaction/imei/details/${merchantId}/${transactionId}`,
  GET_IMEI_BULK_UPLOAD_HISTORY: (merchantId: MerchantIdType): string =>
    `api/v1/dashboard/transaction/imei/bulk/file/history/${merchantId}`,
  DOWNLOAD_IMEI_BULK_HISTORY_FILE: (
    merchantId: MerchantIdType,
    fileId: string
  ): string =>
    `api/v1/dashboard/transaction/imei/bulk/file/download/${merchantId}?fileId=${fileId}`,
  POST_VALIDATE_IMEI: 'api/v1/dashboard/transaction/imei/validate',
  GET_BULK_IMEI_SAMPLE_CSV:
    'api/v1/dashboard/transaction/imei/bulk/file/sample/download',
  GET_EDGE_IMEI_BULK_UPLOAD_CSV_TEMPLATE: `api/v1/unification/pg/dashboard/bulkimei/template`,
  GET_EDGE_IMEI_BULK_UPLOAD_HISTORY: `api/v1/unification/pg/dashboard/bulkimei/history`,
  UPLOAD_BULK_IMEI: (merchantId: MerchantIdType): string =>
    `api/v1/dashboard/transaction/imei/bulk/validate/${merchantId}`,
  UPDATE_MERCHANT_TPV: 'api/v1/dashboard/transaction/merchant/rootuser/tpv',
  UPDATE_MERCHANT_SETTINGS:
    'api/v1/dashboard/transaction/merchant/rootuser/manage-services',
  FETCH_LINKED_TXN_PL: (
    merchantId: MerchantIdType,
    paymentLinkId: string | number
  ): string =>
    `api/v1/payment/transaction/transaction/paymentlink/paymentlink/${merchantId}/${paymentLinkId}`,
  //Offers API Endpoints
  GET_ALL_CAMPAIGNS: (merchantId: MerchantIdType): string =>
    `promotions/api/v1/campaigns/${merchantId}`,
  CREATE_CAMPAIGNS: (merchantId: MerchantIdType): string =>
    `promotions/api/v1/campaigns/${merchantId}`,
  FETCH_CAMPAIGN_DETAIL: (
    merchantId: string | number,
    id: string | number
  ): string => `promotions/api/v1/campaigns/${id}/${merchantId}`,
  MANAGE_CAMPAIGN: (
    campaignId: MerchantIdType,
    merchantId: MerchantIdType
  ): string => `promotions/api/v1/campaigns/${campaignId}/${merchantId}`,
  DOWNLOAD_BIN_FILE: (
    campaignId: MerchantIdType,
    merchantId: MerchantIdType
  ): string =>
    `promotions/api/v1/campaigns/binfile/download/${campaignId}/${merchantId}`,
  FETCH_CAMPAIGN_CONFIG_DATA: 'promotions/api/v1/campaigns/config/data',
  DOWNLOAD_BIN_FILE_TEMPLATE: 'promotions/api/v1/campaigns/binfile/template',
  FETCH_OFFERS_RULE: (merchantId: MerchantIdType): string =>
    `api/v1/dashboard/transaction/settings/rootuser/promotionRule/${merchantId}`,

  // Plans and Subscription
  GET_PLAN_LIST: 'api/v2/dashboard-bff/subscription/plans',
  GET_PLAN_DOWNLOAD: 'api/v2/dashboard-bff/subscription/plans/download',
  CREATE_PLAN_LIST: 'api/v2/dashboard-bff/subscription/plans',
  SEARCH_PLAN: 'api/v2/dashboard-bff/subscription/plans/searchPlan',
  GET_SUBSCRIPTION_LIST: 'api/v2/dashboard-bff/subscription/subscriptions',
  GET_SUBSCRIPTION_DOWNLOAD:
    'api/v2/dashboard-bff/subscription/subscriptions/download',
  GET_SUBSCRIPTION_PRESENTATIONS:
    'api/v2/dashboard-bff/subscription/presentations',
  GET_SUBSCRIPTION_PRESENTATIONS_DOWNLOAD:
    'api/v2/dashboard-bff/subscription/presentations/download',
  SUBSCRIPTION_BULK_UPLOAD: 'api/v2/dashboard-bff/bulk-jobs',
  GET_BULK_UPLOAD_HISTORY: 'api/v2/dashboard-bff/bulk-jobs',
  DOWNLOAD_BULK_JOB_RESPONSE: (jobId: string): string => `api/v2/dashboard-bff/bulk-jobs/${jobId}/response`,

  // Subscription Links
  CREATE_SUBSCRIPTION_LINK: 'api/v2/dashboard-bff/subscription-links',
  GET_SUBSCRIPTION_LINKS: 'api/v2/dashboard-bff/subscription-links',
  EXPORT_SUBSCRIPTION_LINKS: 'api/v2/dashboard-bff/subscription-links/export',
  GET_SUBSCRIPTION_LINK_DETAIL: (id: string): string => `api/v2/dashboard-bff/subscription-links/${id}`,
  GET_SUBSCRIPTION_LINK_BY_REF: (ref: string): string => `api/v2/dashboard-bff/subscription-links/ref/${ref}`,
  CANCEL_SUBSCRIPTION_LINK: (id: string): string => `api/v2/dashboard-bff/subscription-links/${id}/cancel`,
  DUPLICATE_SUBSCRIPTION_LINK: (id: string): string => `api/v2/dashboard-bff/subscription-links/${id}/duplicate`,
  NOTIFY_SUBSCRIPTION_LINK: (id: string): string => `api/v2/dashboard-bff/subscription-links/${id}/notify`,
  UPDATE_SUBSCRIPTION: `api/v2/dashboard-bff/subscription/subscriptions`,
  UPDATE_PLAN: (planId: string | number): string =>
    `api/v2/dashboard-bff/subscription/plans/${planId}`,
  DELETE_PLAN: (planId: string | number): string =>
    `api/v2/dashboard-bff/subscription/plans/${planId}`,
  DELETE_SUBSCRPTION: (query: SubscriptionPayloadProps): string =>
    `api/v2/dashboard-bff/subscription/subscriptions/${query.subscription_id}/${query.status}`,
  GET_TICKET_LIST: (data: {
    accountId: string;
    page: number;
    size: number;
  }): string =>
    `v1/ticket?accountId=${data.accountId}&size=${data.size}&page=${data.page}`,
  GET_TICKET_DETAIL: (ticketId: string): string => `v1/ticket/${ticketId}`,
  GET_ALLCATEGORY: `v1/category?product=PLURAL`,
  GET_SUBCATEGORY: (category: string): string =>
    `v1/category/${category}/subcategory?product=PLURAL`,
  NEW_TICKET: `v1/ticket`,
  UPLOAD_DOCUMENT: `v1/upload`,
  LINK_DOCUMENT_TO_TICKET: (ticketId: string): string =>
    `v1/ticket/${ticketId}/attachments`,
  MERCHANT_PROFILE: `api/v1/dashboard/transaction/merchant/profile`,
  GET_IFSC: (ifsc: string): string =>
    `api/v1/dashboard/transaction/merchant/ifsc/${ifsc}`,
  GET_SIGNZY_TOKEN: `api/v1/dashboard/auth/merchant/getSignzyToken`,
  GET_PAN_TO_GSTLIST: (patronId: string): string =>
    `api/v2/patrons/${patronId}/gstns`,
  GET_PAN_VERIFY: (patronId: string): string =>
    `api/v2/patrons/${patronId}/panv2`,
  GET_BANK_VERIFY: (patronId: string): string =>
    `api/v2/patrons/${patronId}/bankaccountverifications`,
  GET_ALL_COMMENTS: (ticketId: string): string =>
    `v1/ticket/${ticketId}/comment`,
  GET_ALL_ATTACHEMENTS: (ticketId: string): string =>
    `v1/ticket/${ticketId}/attachments`,
  GET_PREVIEW: (ticketId: string, documentId: string): string =>
    `v1/ticket/${ticketId}/attachments/${documentId}`,
  GET_VERIFY_KYC: `api/v1/dashboard/transaction/merchant/kycStatus`,
  GET_STATE: (countryCode: string): string =>
    `/api/v1/dashboard/transaction/home/states?countryCode=${countryCode}`,
  GET_CITY: (countryCode: string): string =>
    `/api/v1/dashboard/transaction/home/cities?stateCode=${countryCode}`,
  GET_EMI_AND_PRODUCT_DETAILS: (data: GetImeiDetailsActionType): string =>
    `api/v1/dashboard/transaction/transaction/EMI/details/${data.transactionId}/${data.merchantId}`,
  GET_WEBHOOK_EVENTS_LIST: `notifications/onboarding/v1/merchants/webhooks`,
  GET_SUBSCRIPTION_EVENTS_LIST: (productSystemCode: string): string =>
    `notifications/onboarding/v1/products/webhooks?productSystemCode=${productSystemCode}`,
  REGISTER_WEBHOOK_EVENTS_LIST:
    'notifications/onboarding/v1/merchants/webhooks/subscribe',
  UNREGISTER_WEBHOOK_EVENTS_LIST:
    'notifications/onboarding/v1/merchants/webhooks/unsubscribe',
  REGISTER_MERCHANT_ON_WEBHOOK: 'notifications/onboarding/v1/merchants',
  BPCL_GET_ALL_MERCHANTS_STAGE_DETAILS:
    'api/v2/dashboard-bff/self-serve/merchants/stage-details',
  BPCL_GET_REVIEW_REQUESTS: 'api/v2/dashboard-bff/self-serve/review-request',
  BPCL_UPDATE_REVIEW_REQUESTS: (req_id: string): string =>
    `api/v2/dashboard-bff/self-serve/update/review-requests/${req_id}/status`,
  BPCL_UPLOAD_BULK_MERCHANT_DATA: 'api/v1/unification/pg/dashboard/bpcl/upload',
  BPCL_DOWNLOAD_TEMPLATE_FOR_BULK_UPLOAD:
    'api/v1/unification/pg/dashboard/bpcl/template',
  BPCL_GET_HISTORY_BULK_UPLOAD: 'api/v1/unification/pg/dashboard/bpcl/history',
  PARTNER_UPLOAD_BULK_MERCHANT_DATA: 'api/v1/unification/pg/dashboard/partner-invite/upload',
  PARTNER_DOWNLOAD_TEMPLATE_FOR_BULK_UPLOAD:
    'api/v1/unification/pg/dashboard/partner-invite/template',
  PARTNER_GET_HISTORY_BULK_UPLOAD: 'api/v1/unification/pg/dashboard/partner-invite/history',
  PARTNER_DOWNLOAD_BULK_UPLOAD_RESULT: (referenceId: string, merchantId: string | number): string =>
    `api/v1/unification/pg/dashboard/partner-invite/download/${referenceId}`,
  GET_STATUS_OF_MERCHANT_ON_WEBHOOK:
    'notifications/onboarding/v1/merchants/products',
  GET_MERCHANT_DETIALS: (merchantId): string =>
    `api/v1/dashboard/transaction/merchant/rootuser/merchantData/${merchantId}`,
  GET_PARTNER_MERCHANT_DETAILS: (merchantId, isParentToChild): string =>
    `api/v1/dashboard/transaction/merchant/merchantData/${merchantId}?isParentToChild=${isParentToChild ? 'true' : 'false'}`,
  SELF_SERVE_UNIFIED_LOGIN: 'self-serve/v1/login',
  UNIFIED_LOGIN: 'api/v1/dashboard/auth/merchant/unified/user/LoginWithCaptcha',
  UNIFIED_FETCH_LOGIN_OTP:
    'api/v1/dashboard/auth/merchant/unified/user/fetchOTPToken',
  UNIFIED_VALIDATE_LOGIN_OTP:
    'api/v1/dashboard/auth/merchant/unified/login/authenticate/otp',
  UNIFIED_FETCH_MERCHANT: (merchantId, email): string =>
    `api/v1/dashboard/auth/merchant/unified/login/data/${merchantId}/${email}`,
  UNIFIED_FORGET_PASSWORD:
    'api/v1/dashboard/auth/merchant/unified/user/forgetpassword',
  UNIFIED_USER_ENV: (emailid: string): string =>
    `api/v1/dashboard/auth/merchant/unified/liveOrTest/${emailid}`,
  UNIFIED_VALIDATE_OTP:
    'api/v1/dashboard/auth/merchant/unified/user/forgetpassword/validate/otp',
  UNIFIED_SAVE_NEW_PASSWORD:
    'api/v1/dashboard/auth/merchant/unified/user/forgetpassword/save/new/password',
  RESET_PASSWORD_WITH_TOKEN: 'plural-onboarding/v1/resetPasswordWithToken',
  UNIFIED_REFRESH_TOKEN: 'api/v1/dashboard/auth/merchant/unified/verify/token',
  UNIFIED_NEW_SIGN_UP: 'api/v1/dashboard/auth/merchant/unified/user/new/login',
  UNIFIED_GET_ACTIVE_USERS: 'api/v1/dashboard/transaction/user/unified/all',
  UNIFIED_GET_ALL_ROLES: 'api/v1/dashboard/transaction/user/unified/roles/all',
  UNIFIED_CREATE_NEW_ROLE:
    'api/v1/dashboard/transaction/user/unified/create/role',
  UNIFIED_CREATE_NEW_USER: 'api/v1/dashboard/transaction/user/unified/create',
  UNIFIED_UPDATE_USER_DETAILS:
    'api/v1/dashboard/transaction/user/unified/update',
  UNIFIED_DELETE_USER: 'api/v1/dashboard/transaction/user/unified/remove',
  UNIFIED_RESEND_INVITATION:
    'api/v1/dashboard/transaction/user/unified/resend/invitation/user',
  UNIFIED_CLIENT_SECRET_KEY: `api/v1/dashboard/auth/merchant/unified/recaptcha/recaptchaKey`,
  UNIFIED_VERIFY_CAPTCHA_API: `api/v1/dashboard/auth/merchant/unified/recaptcha/verify`,
  UNIFIED_GET_MERCHANT_LIST: `api/v1/dashboard/transaction/merchant/unified/rootuser/merchantList`,
  UNIFIED_GET_MERCHANT_MIGRATION_DATA: `api/v1/dashboard/transaction/merchant/rootuser/checkoutMerchant`,
  UNIFIED_MERCHANT_SEARCH: `api/v1/dashboard/transaction/merchant/unified/rootuser/searchMerchant`,
  UNIFIED_MIGRATED_MERCHANT_SEARCH: `api/v1/dashboard/transaction/merchant/rootuser/searchCheckoutMerchant`,
  UNIFIED_VALIDATE_REGISTER_TOKEN: (token: string, isAdmin: boolean): string =>
    `api/v1/dashboard/auth/merchant/unified/validateInviteLink/${token}/${isAdmin}`,
  GET_EDGE_REFUND_BULK_UPLOAD_CSV_TEMPLATE: `api/v1/unification/pg/dashboard/bulkrefund/template`,
  UPLOAD_EDGE_BULK_REFUND: 'api/v1/unification/pg/dashboard/bulkrefund/upload',
  UPLOAD_EDGE_BULK_IMEI: 'api/v1/unification/pg/dashboard/bulkimei/upload',
  GET_EDGE_BULK_UPLOAD_REFUND_HISTORY_LIST:
    'api/v1/unification/pg/dashboard/bulkrefund/history',
  GET_REF_FILE_REFUND_LIST: (refId: string): string =>
    `api/v1/unification/pg/dashboard/bulkrefund/list/${refId}`,
  GET_REFUND_DETAIL: (transaction: string): string =>
    `api/v1/unification/pg/dashboard/bulkrefund/detail/${transaction}`,
  GET_REF_FILE_IMEI_LIST: (refId: string): string =>
    `api/v1/unification/pg/dashboard/bulkimei/list/${refId}`,
  OPS_GET_EDGE_IMEI_BULK_UPLOAD_CSV_TEMPLATE: `api/v1/unification/pg/dashboard/bulkimei/ops/template`,
  OPS_GET_EDGE_IMEI_BULK_UPLOAD_HISTORY: `api/v1/unification/pg/dashboard/bulkimei/ops/history`,
  OPS_GET_EDGE_REFUND_BULK_UPLOAD_CSV_TEMPLATE: `api/v1/unification/pg/dashboard/bulkrefund/ops/template`,
  OPS_UPLOAD_EDGE_BULK_REFUND:
    'api/v1/unification/pg/dashboard/bulkrefund/ops/upload',
  OPS_UPLOAD_EDGE_BULK_IMEI:
    'api/v1/unification/pg/dashboard/bulkimei/ops/upload',
  OPS_GET_EDGE_BULK_UPLOAD_REFUND_HISTORY_LIST:
    'api/v1/unification/pg/dashboard/bulkrefund/ops/history',
  OPS_GET_REF_FILE_REFUND_LIST: (refId: string): string =>
    `api/v1/unification/pg/dashboard/bulkrefund/ops/list/${refId}`,
  OPS_GET_REF_FILE_IMEI_LIST: (refId: string): string =>
    `api/v1/unification/pg/dashboard/bulkimei/ops/list/${refId}`,
  CREATE_V3_REFUND: (orderId: string): string =>
    `api/v3/dashboard/refund/${orderId}`,
  UPDATE_MERCHANT_VERSION:
    'api/v1/dashboard/transaction/merchant/rootuser/merchantVersion',
  GET_EDGE_IMEI_TRANSACTION_LIST: 'api/v2/dashboard-bff/imei/txnListing',
  GET_EDGE_V3_IMEI_TRANSACTION_LIST: 'api/dashboard-bff/imei/v3/txnListing',
  GET_EDGE_IMEI_TRANSACTION_DETAILS: `api/v2/dashboard-bff/imei/txnDetail`,
  GET_EDGE_V3_IMEI_TRANSACTION_DETAILS: `api/dashboard-bff/imei/v3/txnDetail`,
  GET_EDGE_IMEI_VALIDATION_DETAILS: `api/v2/dashboard-bff/imei/imeiDataForValidation`,
  POST_IMEI_BLOCK: `api/v2/dashboard-bff/imei/validateImei`,
  EMAIL_VERIFICATION: `plural-onboarding/v1/emailVerification`,
  RESEND_VERIFICATION_MAIL: (token: string): string =>
    `plural-onboarding/v1/resendEmailVerification/${token}`,
  SEND_OTP_PDF: (payload): string =>
    `api/v1/dashboard/auth/merchant/login/data/unified/user/self-serve/fetchOTPToken?payload=${payload}`,
  VERIFY_OTP_PDF: `api/v1/dashboard/auth/merchant/unified/exist/self-serve-authenticate-otp`,
  SAVE_BUSINESS_DETAILS: 'self-serve/save/businessDetails', // has to be updated
  KYC_VERIFICATION: 'self-serve/validate/kyc', // has to be updated
  FETCH_KYC_DETAILS: 'self-serve/fetch/kyc-details', // has to be updated
  PRODUCTS_LISTING: 'api/v2/dashboard-bff/self-serve/onboarding/products',
  GET_PRODUCTS_LIST_SELECTED: (merchantId: string): string =>
    `merchants/${merchantId}/products`,
  POST_PRODUCTS_LIST_SELECTED: 'self-serve/api/merchants/products',
  PAN_VALIDATION: (pan: string): string =>
    `api/v1/bff/self-serve/validate/pan/${pan}`,
  FETCH_GST_DETAILS: (pan: string): string =>
    `/self-serve/validate/pan/${pan}/gst`,
  GST_VALIDATION: `api/v2/dashboard-bff/self-serve/verify/gst`,
  STATES_DATA: 'api/v2/dashboard-bff/self-serve/states/master-data',
  CITIES_DATA: (stateCode: string): string =>
    `api/v2/dashboard-bff/self-serve/states/${stateCode}/cities`,
  MCC_FROM_GST: `api/v2/dashboard-bff/self-serve/gst/mcc/detailMapping`,
  DIGILOCKER_URL: 'api/v2/dashboard-bff/self-serve/kyc/digilocker/url',
  DIGILOCKER_DETAILS: 'api/v2/dashboard-bff/self-serve/kyc/details',
  DETAILS_FROM_DIGILOCKER: 'self-serve/api/v1/accounts/digilocker/aadhar',
  PAN_AND_GST_DETAILS: (pan): string =>
    `api/v2/dashboard-bff/self-serve/pan/${pan}/pan-verification`,
  SELF_SERVE_GET_STATE_OF_ONBOARDING:
    'api/v2/dashboard-bff/self-serve/onboarding-state',
  SELF_SERVE_SAVE_AND_NEXT: 'api/v2/dashboard-bff/self-serve/merchants/steps',
  SELF_SERVE_AUTOSAVE: 'api/v2/dashboard-bff/self-serve/merchants/steps/autosave',
  SIDEBAR_STEP_CLICK: 'api/v2/dashboard-bff/self-serve/merchants/navigate',
  VIDEO_KYC_URL: 'api/v2/dashboard-bff/self-serve/kyc/video/generateLink',
  VIDEO_KYC_STATUS: 'api/v2/dashboard-bff/self-serve/kyc/video/videoResponse',
  COMPLETE_VIDEO_KYC_JOURNEY:
    'api/v2/dashboard-bff/self-serve/kyc/video/close-journey',
  ASSISTED_VKYC_STATUS: 'api/v2/dashboard-bff/self-serve/assisted/vkyc-status',
  ASSISTED_VKYC_DATA: 'api/v2/dashboard-bff/self-serve/assisted/get-kyc-data',
  ASSISTED_VKYC_UPDATE_SIGNATORY:
    'api/v2/dashboard-bff/self-serve/assisted/update-signatory-details',
  ASSISTED_VKYC_INITIATE:
    'api/v2/dashboard-bff/self-serve/assisted/initiate-vkyc',
  REVIEW_UPDATE_STEP: 'api/v2/dashboard-bff/self-serve/merchants/review',
  SELF_SERVE_BANK_ACCOUNT_VERIFICATION:
    'api/v2/dashboard-bff/self-serve/bank_accounts/validate',
  SHOW_PDF: 'api/v2/dashboard-bff/self-serve/po/generate/agreement',
  SHOW_OPPORTUNITY_STATUS: 'api/v2/dashboard-bff/self-serve/opportunity/status',
  POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION:
    'api/v1/dashboard/auth/merchant/state-by-token',
  SELF_SERVE_TOGGLE: (merchantId, merchantEmail, env): string =>
    `api/v1/dashboard/auth/merchant/unified/env/toggle/${merchantId}/${merchantEmail}/${env}`,
  CIN_NUMBER_VALIDATION: 'api/v2/dashboard-bff/self-serve/cin-details',
  CREATE_REVIEW_REQUEST: 'api/v2/dashboard-bff/self-serve/review-requests',
  DELETE_REVIEW_REQUEST: (reviewRequestId: string) =>
    `api/v2/dashboard-bff/self-serve/review-requests/${reviewRequestId}`,
  CONFIRM_CHILD_SELECTION:
    'api/v2/dashboard-bff/self-serve/review-requests/confirm-child-selection',
  FETCH_UPLOAD_DOCUMENTS: `api/v2/dashboard-bff/self-serve/merchants/documents`,
  DOCUMENTS_UPLOAD: `api/v2/dashboard-bff/self-serve/documents/upload`,
  PCI_DSS_CONSENT: `api/v2/dashboard-bff/self-serve/documents/pci-dss-consent`,
  GENERATE_ESIGN_URL: 'api/v2/dashboard-bff/self-serve/documents-esign/url',
  GET_ESIGN_STATUS: 'api/v2/dashboard-bff/self-serve/kyc/video/esign-status',
  SEND_EMAIL_COMPANY_DIRECTOR:
    'api/v2/dashboard-bff/self-serve/documents-upload/send-email',
  UPDATE_BENEFICIARY_OWNER_DETAILS:
    'api/v2/dashboard-bff/self-serve/beneficiary-owner/update',
  RESEND_EMAIL_BENEFICIARY:
    'api/v2/dashboard-bff/self-serve/beneficiary-owners/send-email',
  GET_BENEFICIARY_OWNERS: 'api/v2/dashboard-bff/self-serve/beneficiary-owners',

  SEND_EMAIL_KYC_AGREEMENT:
    'api/v2/dashboard-bff/self-serve/kyc-agreement-sign/send-email',
  PAN_VALIDATION_KYC_AGREEMENT: 'api/v2/dashboard-bff/self-serve/pan-details',
  AGREEMENT_ESIGN_URL: 'api/v2/dashboard-bff/self-serve/agreement-esign/url',
  DOCUMENT_ESIGN_STATUS:
    'api/v2/dashboard-bff/self-serve/documents-esign/status',
  AGREEMENT_ESIGN_STATUS:
    'api/v2/dashboard-bff/self-serve/agreement-esign/status',
  REJECTION_CLARIFICATION:
    'api/v2/dashboard-bff/self-serve/rejection-clarification',
  GET_PARTNER_TRANSACTION_LIST: `api/v3/dashboard/partner/transactions`,
  GET_PARTNER_MERCHANT_LIST: `api/v3/dashboard/partner/merchants`,
  GET_MERCHANT_SUMMARY_LIST: `api/v3/dashboard/partner/summary`,
  GET_PARTNER_LEAD_SUMMARY: `api/v3/dashboard/partner/lead-summary`,
  GET_PARTNER_ONBOARDING_STAGE_DETAILS: `api/v3/dashboard/partner/onboarding/stage-details`,
  POST_PARTNER_INVITE_MERCHANT: `api/v3/dashboard/partner/onboarding/invite-merchant`,
  GET_PARTNER_PAYMENT_METHODS: `api/v3/dashboard/partner/onboarding/payment-methods`,
  GET_PARTNER_SUB_MERCHANT_LIST: 'api/v3/dashboard/partner/sub-merchants',
  GET_PARTNER_SUMMARY_GRAPH_DATA: 'api/v3/dashboard/partner/graph',
  GET_PARTNER_REPORT_LIST: `api/v3/dashboard/reports`,
  REPORT_FEATURES: 'api/v3/dashboard/reports/categories',
  REPORT_CATEGORY_DETAIL: (categoryId: string, subCategoryId: string): string =>
    `api/v3/dashboard/reports/categories/${categoryId}/subCategories/${subCategoryId}`,
  REPORT_USER_EMAILS: (reportTypeId: string): string =>
    `api/report/v1/users/${reportTypeId}`,
  INSTANT_REPORTS: 'api/v3/dashboard/reports',
  GET_ALL_REPORT_LIST: `api/v3/dashboard/reports`,
  GET_MASTER_LIST: `/api/v3/dashboard/reports/master-status`,
  DOWNLOAD_PARTNER_REPORT: (reportId: string): string =>
    `api/v3/dashboard/reports/download/${reportId}`,
  ADMIN_TRANSACTION: (base64: string, pageNo: number): string =>
    `api/v1/rcu/orchestrator/transaction?payload=${base64}&pageNo=${pageNo}&limit=10`,
  ADMIN_MERCHANT: (base64: string, pageNo: number): string =>
    `api/v1/rcu/orchestrator/merchant?payload=${base64}&pageNo=${pageNo}&limit=10`,
  ADMIN_REFUND_AND_SETTELMENTS: (
    txnId: string,
    platform: string,
    source: string
  ): string => `api/v1/rcu/${platform}/refund/${txnId}?source=${source}`,
  ADMIN_DOWNLOAD_LIST: (
    base64: string,
    mode: string,
    source?: string
  ): string =>
    source
      ? `api/v1/rcu/orchestrator/${mode}/download?payload=${base64}&source=${source}`
      : `api/v1/rcu/orchestrator/${mode}/download?payload=${base64}`,
  BULK_DOWNLOAD_LIST: (base64: string, mode: string): string =>
    `api/v1/rcu/orchestrator/bulk/${mode}?payload=${base64}`,
  PLURAL_TRANSACTION_API: (base64: string, pageNo: number): string =>
    `api/v1/rcu/orchestrator/plural/transaction?payload=${base64}&pageNo=${pageNo}&limit=10`,
  EDGE_TRANSACTION_API: (base64: string, pageNo: number): string =>
    `api/v1/rcu/orchestrator/edge/transaction?payload=${base64}&pageNo=${pageNo}&limit=10`,
  EDGE_TRANSACTION_GENERIC_API: (base64: string, pageNo: number): string =>
    `api/v1/rcu/orchestrator/rcuGenericSearch?payload=${base64}&pageNo=${pageNo}&limit=10`,
  EDGE_TRANSACTION_GENERIC_API_DOWNLOAD: (
    base64: string,
    pageNo: number
  ): string =>
    `api/v1/rcu/orchestrator/rcuGenericSearch?payload=${base64}&pageNo=${pageNo}&limit=10&isDownload=true`,
  EDGE_TRANSACTION_API_DOWNLOAD: (base64: string) =>
    `api/v1/rcu/orchestrator/edge/transaction?payload=${base64}&pageNo=1&limit=10&isDownload=true`,
  ACQUIRERS: 'api/v1/unification/pg/dashboard/rcu/acquirer',
  ADMIN_POST_SETTLEMENT:
    'api/v1/dashboard/auth/merchant/settlements/transaction/list',
  ADMIN_POST_REFUND: 'api/v1/dashboard/auth/merchant/refund/data/transaction',
  RCU_COMPLETE_DOWNLOAD: (base64: string) =>
    `api/v1/rcu/orchestrator/rcuCompleteDownload?payload=${base64}`,
  UPDATE_MAX_PAYMENT_LINK: `api/v1/dashboard/transaction/merchant/updatepbllimit`,
  GET_MERCHANT_SETTINGS_FLAG: 'api/v1/unification/pg/dashboard/settings/flag',
  SET_MERCHANT_SETTINGS_FLAG: 'api/v1/unification/pg/dashboard/settings/convenience-fee-refund',
  GET_CHECKOUT_VERSION: 'api/v3/dashboard/merchantDetails',
  GET_HAS_MERCHANT_TRANSACTED: 'api/v3/dashboard/merchant/has-transacted',

  GET_CUSTOMER_WALLET: 'api/v1/dashboard-bff/brand-wallet/customer/wallet',
  ACTIVATE_DEACTIVATE_WALLET: 'api/v1/dashboard-bff/brand-wallet/activate-deactivate',
  CREATE_WALLET: 'api/v1/dashboard-bff/brand-wallet/create-wallet',
  LOAD_WALLET: 'api/v1/dashboard-bff/brand-wallet/load-wallet',
  LIST_CREATED_WALLET: 'api/v1/dashboard-bff/brand-wallet/list-created-wallet',
  LIST_LOAD_WALLET: 'api/v1/dashboard-bff/brand-wallet/list-load-wallet',
  DOWNLOAD_ERRORS: 'api/v1/dashboard-bff/brand-wallet/download-error-records',
  DOWNLOAD_CUSTOMER_LIST: 'api/v1/dashboard-bff/brand-wallet/download/customer/list',
  GET_TRANSACTION_DETAILS: 'api/v1/dashboard-bff/brand-wallet/customer/transaction-details',
  GET_WALLET_BALANCE : 'api/v1/dashboard-bff/brand-wallet/wallet/balance',
  DONWLOAD_SAMPLE_PDF_MONEY_LOAD: 'api/v1/dashboard-bff/brand-wallet/download/sample/money-load',
  DOWNLOAD_SAMPLE_PDF_CREATE_WALLET: 'api/v1/dashboard-bff/brand-wallet/download/sample/create-wallet',

  // api for apple pay
  GET_DOWNLOAD_CSR_APPLE_PAY: `api/v2/dashboard-bff/applePay/generate-csr`,
  GET_APPLE_PAY_WALLET_STATUS: 'api/v2/dashboard-bff/applePay/wallet-status',
  GET_APPLE_PAY_INTEGRATION_STATUS:
    'api/v2/dashboard-bff/applePay/integration-channel',
  WEB_REGISTRATION_APPLE_PAY: 'api/v2/dashboard-bff/applePay/web-registration',
  ACTIVATE_APPLE_PAY_CERTIFICATES:
    'api/v2/dashboard-bff/applePay/activate-certifications',

  // api for payment modes

  // GET_PAYMENT_MODES: `api/v2/dashboard-bff/self-serve/payment-modes-status`,

  GET_PAYMENT_MODES: (emailId: string) =>
    `api/v2/dashboard-bff/self-serve/payment-modes-status?emailId=${emailId}`,
  FETCH_PAYMENT_MODES: `api/v2/dashboard-bff/self-serve/fetch/data`,
  CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE:
    'api/v3/dashboard-bff/overview/checkout-insights/payment-performance',
  CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS:
    'api/v3/dashboard-bff/overview/checkout-insights/offer-effectiveness',
  CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN:
    'api/v3/dashboard-bff/overview/checkout-insights/payment-mode-breakdown',
  CHECKOUT_INSIGHTS_CONVERSION_FUNNEL:
    'api/v3/dashboard-bff/overview/checkout-insights/conversion-summary',
  REFUND_VIA_PAYOUT: (orderid: string) => `api/v3/dashboard/payout/${orderid}`,
  DOWNLOAD_DOCUMENT_VIA_URL:
    'api/v2/dashboard-bff/self-serve/download-document',

  // public endpoints for non director

  // document upload page
  PUBLIC_DOCUMENTS_UPLOAD:
    'api/v1/dashboard/auth/merchant/documents/upload/non-director',
  PUBLIC_GENERATE_ESIGN_URL:
    'api/v1/dashboard/auth/merchant/documents-esign/url/non-director',
  PUBLIC_FETCH_DOCUMENTS:
    'api/v1/dashboard/auth/merchant/documents/non-director',
  PUBLIC_ESIGN_STATUS:
    'api/v1/dashboard/auth/merchant/documents-esign/status/non-director',

  // kyc agreement page

  PUBLIC_PAN_VALIDATION_KYC_AGREEMENT:
    'api/v1/dashboard/auth/merchant/pan-details/non-director',
  PUBLIC_DIGILOCKER_URL:
    'api/v1/dashboard/auth/merchant/kyc/digilocker/url/non-director',
  PUBLIC_DIGILOCKER_DETAILS:
    'api/v1/dashboard/auth/merchant/kyc/details/non-director',
  PUBLIC_SHOW_PDF:
    'api/v1/dashboard/auth/merchant/generate/agreement/non-director',
  PUBLIC_AGREEMENT_ESIGN_URL:
    'api/v1/dashboard/auth/merchant/agreement-esign/url/non-director',
  PUBLIC_AGREEMENT_ESIGN_STATUS:
    'api/v1/dashboard/auth/merchant/agreement-esign/status/non-director',
  PUBLIC_STATE_DATA:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/states-master-data',
  PUBLIC_DOWNLOAD_DOCUMENT_VIA_URL:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/document-download',
  PUBLIC_OPPORTUNITY_STATUS:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/opportunity-status',
  PUBLIC_VIDEO_KYC_URL:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/generate-video-link',
  PUBLIC_VIDEO_KYC_STATUS:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/video-response',
  PUBLIC_COMPLETE_VIDEO_KYC_JOURNEY:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/close-journey',
  PUBLIC_MAP_CKYC_DATA:
    'api/v1/dashboard/auth/merchant/self-serve/non-director/dynamic/map-ckyc-data',

  // ckyc apis
  SEND_VERIFICATION_CODE_CKYC:
    'api/v2/dashboard-bff/self-serve/send-verification-code-ckyc',
  VERIFY_CKYC_OTP: 'api/v2/dashboard-bff/self-serve/ckyc-data',
  CKYC_DOWNLOAD_DATA: 'api/v2/dashboard-bff/self-serve/ckyc-download-data',
  MAP_CKYC_DATA: 'api/v2/dashboard-bff/self-serve/merchants/map-ckyc-data',
  CREATE_SCHEDULE_REPORT: 'api/v3/dashboard/reports/scheduled-report',
  CUSTOM_REPORT: 'api/v3/dashboard/reports/custom-report',

  // Maker-Checker endpoints
  MAKER_CHECKER_SUBMIT_REQUEST: 'api/v2/dashboard-bff/maker-checker/approvals',
  MAKER_CHECKER_GET_REQUESTS: 'api/v2/dashboard-bff/maker-checker/requests',
  MAKER_CHECKER_GET_REQUEST_DETAILS: (requestId: string): string => `api/v2/dashboard-bff/maker-checker/requests/${requestId}`,
  MAKER_CHECKER_APPROVE_REQUEST: (requestId: string): string => `api/v2/dashboard-bff/maker-checker/requests/${requestId}/approve`,
  MAKER_CHECKER_REJECT_REQUEST: (requestId: string): string => `api/v2/dashboard-bff/maker-checker/requests/${requestId}/reject`,
  MAKER_CHECKER_GET_EXECUTION_STATUS: (requestId: string): string => `api/v2/dashboard-bff/maker-checker/requests/${requestId}/execution`,
  MAKER_CHECKER_VERIFY_ORDER: (orderId: string): string => `api/v2/dashboard-bff/maker-checker/orders/${orderId}/verify`,

  // Fee Configuration endpoints
  FEE_CONFIG_GET_CONVENIENCE_FEES: 'api/v2/dashboard-bff/fee-configuration/convenience-fees',
  FEE_CONFIG_GET_CONVENIENCE_FEE_DETAIL: (feeId: string): string => `api/v2/dashboard-bff/fee-configuration/convenience-fees/${feeId}`,
  FEE_CONFIG_GET_FEATURE_FEES: 'api/v2/dashboard-bff/fee-configuration/feature-fees',
  FEE_CONFIG_GET_MERCHANT_MAPPINGS: (feeId: string): string => `api/v2/dashboard-bff/fee-configuration/merchant-mappings/${feeId}`,
  FEE_CONFIG_GET_MERCHANT_FEE_MAPPINGS: (merchantId: string): string => `api/v2/dashboard-bff/fee-configuration/merchant/${merchantId}/convenience-fee-mappings`,
  FEE_CONFIG_GET_PAYMENT_MODES: 'api/v2/dashboard-bff/fee-configuration/payment-modes',
  FEE_CONFIG_GET_NETWORK_TYPES: 'api/v2/dashboard-bff/fee-configuration/network-types',
  // Disputes / Chargebacks
  GET_DISPUTES_LIST: 'api/v2/dashboard-bff/chargeBack/list',
  GET_DISPUTE_DETAILS: (chargebackId: string): string => `api/v2/dashboard-bff/chargeBack/details/${chargebackId}`,
  GET_DISPUTE_DOCUMENT_CONFIG: 'api/v2/dashboard-bff/chargeBack/documents-config',
  GET_DISPUTES_LIST_DOWNLOAD: 'api/v2/dashboard-bff/chargeBack/download',
  UPLOAD_CHARGEBACK_DOCUMENT : (chargeBackId : string) =>  `api/v2/dashboard-bff/chargeBack/${chargeBackId}/upload-documents`,
  REUPLOAD_CHARGEBACK_DOCUMENT : (chargeBackId : string) =>  `api/v2/dashboard-bff/chargeBack/${chargeBackId}/reupload-documents`,
  GET_DISPUTES_FEATURE_ENABLED_FLAG: 'api/v2/dashboard-bff/chargeBack/merchant-enabled',
  // Split Settlement
  SPLIT_SETTLEMENT_GET_CHILDREN: 'api/v2/dashboard-bff/split-settlement/children',
  SPLIT_SETTLEMENT_UPDATE_CHILD: (childMerchantId: string | number): string => `api/v2/dashboard-bff/split-settlement/children/${childMerchantId}`,
  SPLIT_SETTLEMENT_GET_AUDIT: 'api/v2/dashboard-bff/split-settlement/audit',
};
